import type { FC } from "react"
import type { PopoverProps } from "antd"
import { Flex, Popover, Typography } from "antd"
import kefuQrcodeUrl from "~/assets/wxkf.png"
import styles from "./index.css"

const { Text, Title } = Typography

export const ContactPopover: FC<PopoverProps> = (props) => {
  return (
    <Popover
      arrow={false}
      classNames={{
        container: styles.contactPopoverContainer,
        root: styles.contactPopoverRoot,
      }}
      content={<ContactPopoverContent />}
      placement="top"
      trigger="click"
      {...props}
    />
  )
}

const ContactPopoverContent = () => {
  return (
    <Flex
      align="center"
      gap={4}
      vertical
    >
      <img
        alt="客服微信二维码"
        className={styles.qrcode}
        src={kefuQrcodeUrl}
      />
      <Title level={5}>联系人工客服</Title>
      <Text type="secondary">升级会员 ｜ 充值积点 ｜ 问题咨询</Text>
      <Text type="secondary">官方客服在线，极速响应</Text>
    </Flex>
  )
}
